import { POSTING, COMPLETED } from '../Actions/types';
import initialState from './initial-state';

export default function(state = initialState.status, action) {
  switch (action.type) {
    
    case POSTING:
    return { ...state, posting: true, success: false };

    case COMPLETED:
    return { ...state, posting: false, success: action.payload };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/statusReducer.js